export default __webpack_public_path__ + "static/media/laundry.edbd71fc.png";